export default __webpack_public_path__ + "e11e72f753f3515f605f0dd87d2dc40f.png";